import {
  isArchivedFieldColumnDefinition,
  isWithSchemaFieldColumnDefinition,
} from 'notebook/structured-tables/columns/ColumnDefinitions';
import {ColumnConstraint, MultiSelectionBox, TableData} from 'notebook/tables/TableConstants';
import {Optional} from 'util/Types';

export function getSchemaFieldApiIdFromColumnConstraint(
  columnConstraint: Optional<ColumnConstraint>,
  includeArchived: boolean = true
): string | null {
  if (columnConstraint == null || !columnConstraint.columnDefinition) {
    return null;
  }

  const {columnDefinition} = columnConstraint;
  if (
    columnDefinition &&
    isWithSchemaFieldColumnDefinition(columnDefinition) &&
    (includeArchived || !isArchivedFieldColumnDefinition(columnDefinition))
  ) {
    return columnDefinition.tagSchemaFieldApiId;
  }

  return null;
}

export function getSchemaFieldApiIdForColumn(
  columnConstraints: Optional<Array<Optional<ColumnConstraint>>>,
  columnIndex: number,
  includeArchived: boolean = true
): string | null {
  if (columnConstraints) {
    return getSchemaFieldApiIdFromColumnConstraint(columnConstraints[columnIndex], includeArchived);
  }
  return null;
}

export function getSchemaFieldApiIdsInTableSelection(
  table: TableData,
  multiSelectionBox: MultiSelectionBox,
  includeArchived: boolean = true
): Array<string> {
  const schemaFieldApiIds = [];
  for (let j = multiSelectionBox.minJ; j <= multiSelectionBox.maxJ; j++) {
    const schemaFieldApiId = getSchemaFieldApiIdForColumn(table.columnConstraints, j, includeArchived);
    if (schemaFieldApiId) {
      schemaFieldApiIds.push(schemaFieldApiId);
    }
  }
  return schemaFieldApiIds;
}
